import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  connect() {
    $(this.element).on('shown.bs.dropdown', function () {
      $(this).find('.form-control').trigger("focus")
    });
  }

  disconnect() {
    $(this.element).off('shown.bs.dropdown');
  }
}